export const ATTRIBUTION_MODEL_FIELDS = {
    mediaType: {
        label: "Media Type",
        description: "Media channel queried from explore_conversion.media_type. Request it to break a multi-channel query out by channel (VIDEO, AUDIO, DISPLAY); omit it for cross-channel totals. Dashboard tiles manage it themselves rather than offering it as a dimension.",
        id: "mediaType",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: false,
        isGroupingOnlyDimension: true
    },
    totalImpressions: {
        label: "Total Impressions",
        description: "Total number of ad impressions delivered",
        id: "totalImpressions",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    totalCompletes: {
        label: "Total Completes",
        description: "Total number of completed ad views",
        id: "totalCompletes",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    totalReach: {
        label: "Total Reach",
        description: "Total unique users reached",
        id: "totalReach",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    averageFrequency: {
        label: "Average Frequency",
        description: "Average number of times a user saw the ad",
        id: "averageFrequency",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    totalClicks: {
        label: "Total Clicks",
        description: "Total number of clicks on ads",
        id: "totalClicks",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    clickThroughRate: {
        label: "Click Through Rate",
        description: "Percentage of impressions that resulted in clicks",
        id: "clickThroughRate",
        reportTypes: ["DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "percentage",
        canBeQueriedWithFootfall: true
    },
    viewCompletionRate: {
        label: "View Completion Rate",
        description: "Percentage of video ads that were completed",
        id: "viewCompletionRate",
        reportTypes: ["VIDEO"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "percentage",
        canBeQueriedWithFootfall: true
    },
    listenThroughRate: {
        label: "Listen Through Rate",
        description: "Percentage of audio ads that were listened to completion",
        id: "listenThroughRate",
        reportTypes: ["AUDIO"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "percentage",
        canBeQueriedWithFootfall: true
    },
    totalConversions: {
        label: "Total Conversions",
        description: "Total number of conversions attributed to campaign",
        id: "totalConversions",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    conversionRate: {
        label: "Conversion Rate",
        description: "Percentage of impressions that resulted in conversions",
        id: "conversionRate",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "percentage",
        canBeQueriedWithFootfall: true
    },
    uniqueConversions: {
        label: "Unique Conversions",
        description: "Number of unique users who converted",
        id: "uniqueConversions",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    uniqueConversionRate: {
        label: "Unique Conversion Rate",
        description: "Percentage of unique users who converted",
        id: "uniqueConversionRate",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "percentage",
        canBeQueriedWithFootfall: true
    },
    campaignName: {
        label: "Campaign",
        description: "Name of the advertising campaign",
        id: "campaignName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "campaignId",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    advertiserName: {
        label: "Advertiser Name",
        description: "Name of the advertiser",
        id: "advertiserName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    congressionalDistrict: {
        label: "Congressional District",
        description: "Congressional district where impression occurred",
        id: "congressionalDistrict",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "congressionalDistrictCode",
        canUserQueryBy: true
    },
    congressionalDistrictCode: {
        label: "Congressional District Code",
        description: "Code for congressional district",
        id: "congressionalDistrictCode",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    creativeName: {
        label: "Creative",
        description: "Name of the creative asset",
        id: "creativeName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "creativeId",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    date: {
        label: "Date",
        description: "Date of impression",
        id: "date",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    week: {
        label: "Week",
        description: "Week of impression",
        id: "week",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    dayOfWeek: {
        label: "Day of Week",
        description: "Day of the week when impression occurred",
        id: "dayOfWeek",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    dayOfMonth: {
        label: "Day of Month",
        description: "Day of the month when impression occurred",
        id: "dayOfMonth",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    hourOfDay24: {
        label: "Hour of Day (24)",
        description: "Hour of the day in 24-hour format",
        id: "hourOfDay24",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    hourOfDay12: {
        label: "Hour of Day (12)",
        description: "Hour of the day in 12-hour format",
        id: "hourOfDay12",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    hourOfWeek: {
        label: "Hour of Week",
        description: "Hour of the week when impression occurred",
        id: "hourOfWeek",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    daypart: {
        label: "Daypart",
        description: "Daypart when ad was delivered",
        id: "daypart",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    deviceType: {
        label: "Device Type",
        description: "Type of device where ad was displayed",
        id: "deviceType",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    subtype: {
        label: "Subtype",
        description: "Video supply subtype (OTT/OLV)",
        id: "subtype",
        reportTypes: ["VIDEO"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    daysToConversion: {
        label: "Days to Conversion",
        description: "Number of days between impression and conversion",
        id: "daysToConversion",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        isConversionField: true
    },
    frequency: {
        label: "Frequency",
        description: "Frequency bucket for ad exposure",
        id: "frequency",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        isExclusiveFrequencyDimension: true
    },
    metro: {
        label: "Metro",
        description: "Metro area where impression occurred",
        id: "metro",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "metroCode",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    metroCode: {
        label: "Metro Code",
        description: "Code for metro area",
        id: "metroCode",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    lineitemName: {
        label: "Line Item",
        description: "Name of the line item",
        id: "lineitemName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "lineitemId",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    publisherName: {
        label: "Publisher",
        description: "Name of the publisher",
        id: "publisherName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    creativeSize: {
        label: "Creative Size",
        description: "Size of the creative",
        id: "creativeSize",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    state: {
        label: "State",
        description: "State where impression occurred",
        id: "state",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "stateCode",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    stateCode: {
        label: "State Code",
        description: "Code for state",
        id: "stateCode",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    zipCode: {
        label: "Zip Code",
        description: "Zip code where impression occurred",
        id: "zipCode",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        canBeQueriedWithFootfall: true
    },
    contentLanguage: {
        label: "Content Language",
        description: "Language of the content",
        id: "contentLanguage",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    month: {
        label: "Month",
        description: "Month of impression",
        id: "month",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    monthOfYear: {
        label: "Month",
        description: "Month of the year when impression occurred",
        id: "monthOfYear",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true
    },
    beaconName: {
        label: "Pixel",
        description: "Name of the conversion pixel",
        id: "beaconName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "beaconId",
        isBeaconField: true,
        canUserQueryBy: true
    },
    beaconId: {
        label: "Pixel ID",
        description: "Unique identifier for conversion pixel",
        id: "beaconId",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isBeaconField: true
    },
    beaconUrl: {
        label: "URL",
        description: "URL where conversion occurred",
        id: "beaconUrl",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "beaconId",
        isBeaconField: true,
        isUniversalPixelField: true,
        canUserQueryBy: true
    },
    beaconPath: {
        label: "Page Path",
        description: "Page path where conversion occurred",
        id: "beaconPath",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "beaconId",
        isBeaconField: true,
        isUniversalPixelField: true,
        canUserQueryBy: true
    },
    pageCategory: {
        label: "Page Category (Beta)",
        description: "Universal (cross-vertical) page category classified from the page URL where the conversion occurred",
        id: "pageCategory",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isBeaconField: true,
        isUniversalPixelField: true,
        canUserQueryBy: true
    },
    pageCategoryAdvertiserVertical: {
        label: "Page Category - Advertiser Vertical (Beta)",
        description: "Vertical (industry-specific) page category classified from the page URL where the conversion occurred and the advertiser's IAB vertical",
        id: "pageCategoryAdvertiserVertical",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isBeaconField: true,
        isUniversalPixelField: true,
        canUserQueryBy: true
    },
    vin: {
        label: "Vehicle VIN",
        description: "Vehicle VIN decoded from the VIN captured by the Universal Pixel. Automotive-category advertisers only; NULL for all other advertisers.",
        id: "vin",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isVehicleDetailsField: true,
        canUserQueryBy: true
    },
    make: {
        label: "Vehicle Make",
        description: "Vehicle make decoded from the VIN captured by the Universal Pixel. Automotive-category advertisers only; NULL for all other advertisers.",
        id: "make",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isVehicleDetailsField: true,
        canUserQueryBy: true
    },
    model: {
        label: "Vehicle Model",
        description: "Vehicle model decoded from the VIN captured by the Universal Pixel. Automotive-category advertisers only; NULL for all other advertisers.",
        id: "model",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isVehicleDetailsField: true,
        canUserQueryBy: true
    },
    year: {
        label: "Vehicle Year",
        description: "Vehicle year decoded from the VIN captured by the Universal Pixel. Automotive-category advertisers only; NULL for all other advertisers.",
        id: "year",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isVehicleDetailsField: true,
        canUserQueryBy: true
    },
    conversionType: {
        label: "Conversion Type",
        description: "Universal Pixel conversion type",
        id: "conversionType",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canUserQueryBy: true
    },
    eventType: {
        label: "Event Type",
        description: "Universal Pixel event type",
        id: "eventType",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canUserQueryBy: true
    },
    formName: {
        label: "Form Name",
        description: "Form name captured on Universal Pixel form submission events",
        id: "formName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canUserQueryBy: true
    },
    buttonName: {
        label: "Button Name",
        description: "Button label captured on Universal Pixel contact events",
        id: "buttonName",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canUserQueryBy: true
    },
    contactType: {
        label: "Contact Type",
        description: "Contact method (phone, email, chat) captured on Universal Pixel contact events",
        id: "contactType",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canUserQueryBy: true
    },
    cartItems: {
        label: "Cart Items",
        description: "Cart items captured on Universal Pixel add to cart events",
        id: "cartItems",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canUserQueryBy: true
    },
    orderId: {
        label: "Order ID",
        description: "Order ID captured on Universal Pixel purchase events",
        id: "orderId",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canUserQueryBy: true
    },
    campaignId: {
        label: "Campaign ID",
        description: "Unique identifier for campaign",
        id: "campaignId",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    creativeId: {
        label: "Creative ID",
        description: "Unique identifier for creative",
        id: "creativeId",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    lineitemId: {
        label: "Line Item ID",
        description: "Unique identifier for line item",
        id: "lineitemId",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canBeQueriedWithFootfall: true
    },
    optimizationType: {
        label: "Optimization Type",
        description: "Optimization goal configured on the line item (CVR, REACH, VCR, CTR, LTR), or None when optimization is not enabled. Reflects the line item's current setting",
        id: "optimizationType",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: false,
        canBeQueriedWithFootfall: true
    },
    isOptimized: {
        label: "Is Optimized",
        description: "Yes when the line item has optimization enabled, No for baseline line items",
        id: "isOptimized",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: false,
        canBeQueriedWithFootfall: true
    },
    bucketDateRange: {
        label: "Bucket Date Range",
        description: "Date range bucket for grouping",
        id: "bucketDateRange",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    mediaCost: {
        label: "Media Cost",
        description: "Cost of media spend",
        id: "mediaCost",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    audienceCost: {
        label: "Audience Cost",
        description: "Cost of audience targeting",
        id: "audienceCost",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    totalSpend: {
        label: "Total Spend",
        description: "Total campaign spend",
        id: "totalSpend",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    costPerMille: {
        label: "CPM",
        description: "Cost per thousand impressions",
        id: "costPerMille",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    costPerConversion: {
        label: "Cost Per Conversion",
        description: "Cost per conversion",
        id: "costPerConversion",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    costPerClick: {
        label: "Cost Per Click",
        description: "Total spend divided by clicks",
        id: "costPerClick",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "none",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    costPerCompletedView: {
        label: "CPCV",
        description: "Cost per completed view: total spend divided by completes",
        id: "costPerCompletedView",
        reportTypes: ["VIDEO", "AUDIO"],
        type: "metric",
        metricSource: "impression",
        operation: "none",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    supplementalCost: {
        label: "Supplemental Cost",
        description: "Additional supplemental costs",
        id: "supplementalCost",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "currency",
        isSpendField: true,
        canBeQueriedWithFootfall: true
    },
    footfallVisitorsImpressionTime: {
        label: "Footfall Visitors (Impression Time)",
        description: "Number of unique visitors attributed based on impression time",
        id: "footfallVisitorsImpressionTime",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        isFootfallField: true
    },
    footfallVisitsImpressionTime: {
        label: "Footfall Visits (Impression Time)",
        description: "Number of visits attributed based on impression time",
        id: "footfallVisitsImpressionTime",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        isFootfallField: true
    },
    footfallVisitorsConversionTime: {
        label: "Footfall Visitors (Conversion Time)",
        description: "Number of unique visitors attributed based on conversion time",
        id: "footfallVisitorsConversionTime",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        isFootfallField: true,
        isConversionTime: true
    },
    footfallVisitsConversionTime: {
        label: "Footfall Visits (Conversion Time)",
        description: "Number of visits attributed based on conversion time",
        id: "footfallVisitsConversionTime",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        isFootfallField: true,
        isConversionTime: true
    },
    pageViewConversions: {
        label: "Page View Conversions",
        description: "Universal Pixel page view conversion events",
        id: "pageViewConversions",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canBeQueriedWithFootfall: true,
        isConversionTypeMetric: true
    },
    leadConversions: {
        label: "Lead Conversions",
        description: "Universal Pixel lead conversion events",
        id: "leadConversions",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canBeQueriedWithFootfall: true,
        isConversionTypeMetric: true
    },
    purchaseConversions: {
        label: "Purchase Conversions",
        description: "Universal Pixel purchase conversion events",
        id: "purchaseConversions",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canBeQueriedWithFootfall: true,
        isConversionTypeMetric: true
    },
    purchaseRevenue: {
        label: "Total Revenue",
        description: "Sum of the revenue value captured on Universal Pixel purchase conversion events",
        id: "purchaseRevenue",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "currency",
        isUniversalPixelField: true,
        // Revenue is the value carried on purchase conversion events, so it is only
        // meaningful where those events are enumerated.
        isUpConversionEventField: true,
        canBeQueriedWithFootfall: true
    },
    roas: {
        label: "ROAS",
        description: "Return on Ad Spend: Universal Pixel purchase revenue divided by Total Spend. Spend is what the client pays Madhive, not Retail Ad Cost",
        id: "roas",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "none",
        unit: "none",
        isSpendField: true,
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canBeQueriedWithFootfall: true
    },
    addToCartValue: {
        label: "Add to Cart Value",
        description: "Sum of the cart value captured on Universal Pixel add to cart events",
        id: "addToCartValue",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "currency",
        isUniversalPixelField: true,
        isUpConversionEventField: true,
        canBeQueriedWithFootfall: true
    },
    linearOnlyAverageFrequency: {
        label: "Linear Average Frequency",
        description: "Average frequency for linear-only exposures",
        id: "linearOnlyAverageFrequency",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    linearOnlyConversionRate: {
        label: "Linear Conversion Rate",
        description: "Conversion rate for linear-only exposures",
        id: "linearOnlyConversionRate",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "percentage"
    },
    linearOnlyProjectedHouseholds: {
        label: "Linear Unique Reach",
        description: "Unique household reach for linear-only exposures",
        id: "linearOnlyProjectedHouseholds",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    linearOnlyProjectedImpressions: {
        label: "Linear Impressions",
        description: "Total impressions for linear-only exposures",
        id: "linearOnlyProjectedImpressions",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    linearOnlyProportionReach: {
        label: "Linear Campaign Reach Share %",
        description: "Percentage of campaign reach from linear-only exposures",
        id: "linearOnlyProportionReach",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    households: {
        label: "TV HHs",
        description: "Total TV households",
        id: "households",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    linearSample: {
        label: "Linear Sample",
        description: "Linear sample size",
        id: "linearSample",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    linearSampleMarket: {
        label: "Linear Sample Market %",
        description: "Linear sample as percentage of market",
        id: "linearSampleMarket",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    ottAverageFrequency: {
        label: "OTT Average Frequency",
        description: "Average frequency for OTT exposures",
        id: "ottAverageFrequency",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    ottOnlyConversionRate: {
        label: "OTT Conversion Rate",
        description: "Conversion rate for OTT-only exposures",
        id: "ottOnlyConversionRate",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "percentage"
    },
    ottProjectedHouseholds: {
        label: "OTT Unique Reach",
        description: "Unique household reach for OTT exposures",
        id: "ottProjectedHouseholds",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    ottProjectedImpressions: {
        label: "OTT Impressions",
        description: "Total impressions for OTT exposures",
        id: "ottProjectedImpressions",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    ottProportionReach: {
        label: "OTT Campaign Reach Share %",
        description: "Percentage of campaign reach from OTT exposures",
        id: "ottProportionReach",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    overlapAverageFrequency: {
        label: "Overlap Average Frequency",
        description: "Average frequency for overlap exposures",
        id: "overlapAverageFrequency",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    overlapConversionRate: {
        label: "Overlap Conversion Rate",
        description: "Conversion rate for overlap exposures",
        id: "overlapConversionRate",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "percentage"
    },
    overlapProjectedHouseholds: {
        label: "Overlap Unique Reach",
        description: "Unique household reach for overlap exposures",
        id: "overlapProjectedHouseholds",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    overlapProjectedImpressions: {
        label: "Overlap Impressions",
        description: "Total impressions for overlap exposures",
        id: "overlapProjectedImpressions",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    overlapProportionReach: {
        label: "Overlap Campaign Reach Share %",
        description: "Percentage of campaign reach from overlap exposures",
        id: "overlapProportionReach",
        reportTypes: ["OVERLAP"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    linearAdvertiserId: {
        label: "Advertiser ID",
        description: "Unique identifier for advertiser",
        id: "linearAdvertiserId",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearAdvertiserName: {
        label: "Advertiser Name",
        description: "Name of the advertiser",
        id: "linearAdvertiserName",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearBeaconId: {
        label: "Beacon ID",
        description: "Unique identifier for conversion pixel",
        id: "linearBeaconId",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isBeaconField: true,
        impressionThreshold: 250
    },
    linearBeaconName: {
        label: "Pixel",
        description: "Name of the conversion pixel",
        id: "linearBeaconName",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "linearBeaconId",
        isBeaconField: true,
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearCreativeCode: {
        label: "Creative Code",
        description: "Code for creative asset",
        id: "linearCreativeCode",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearCreativeName: {
        label: "Creative",
        description: "Name of the creative asset",
        id: "linearCreativeName",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "linearCreativeCode",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearDaypartName: {
        label: "Daypart",
        description: "Daypart when ad was delivered",
        id: "linearDaypartName",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearImpressionDate: {
        label: "Date",
        description: "Date of impression",
        id: "linearImpressionDate",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearImpressionHourOfWeek: {
        label: "Hour of Week",
        description: "Hour of the week when impression occurred",
        id: "linearImpressionHourOfWeek",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearImpressionHourOfDay12: {
        label: "Hour of Day (12)",
        description: "Hour of the day in 12-hour format",
        id: "linearImpressionHourOfDay12",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearImpressionHourOfDay24: {
        label: "Hour of Day (24)",
        description: "Hour of the day in 24-hour format",
        id: "linearImpressionHourOfDay24",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearImpressionMonth: {
        label: "Month",
        description: "Month of impression",
        id: "linearImpressionMonth",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearImpressionMonthOfYear: {
        label: "Month",
        description: "Month of the year when impression occurred",
        id: "linearImpressionMonthOfYear",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearImpressionWeek: {
        label: "Week",
        description: "Week of impression",
        id: "linearImpressionWeek",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearImpressionWeekOfYear: {
        label: "Week of Year",
        description: "Week of the year when impression occurred",
        id: "linearImpressionWeekOfYear",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearImpressionYear: {
        label: "Year",
        description: "Year of impression",
        id: "linearImpressionYear",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearMetroName: {
        label: "Metro",
        description: "Metro area where impression occurred",
        id: "linearMetroName",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        fetchWithField: "linearMetroCode",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearMetroCode: {
        label: "Metro Code",
        description: "Code for metro area",
        id: "linearMetroCode",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        impressionThreshold: 250
    },
    linearNetworkName: {
        label: "Network",
        description: "Name of the network",
        id: "linearNetworkName",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearProgramName: {
        label: "Program",
        description: "Name of the program",
        id: "linearProgramName",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        impressionThreshold: 250
    },
    linearDaysToConversion: {
        label: "Days to Conversion",
        description: "Number of days between impression and conversion",
        id: "linearDaysToConversion",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none"
    },
    linearFrequency: {
        label: "Frequency",
        description: "Frequency bucket for linear creative exposure",
        id: "linearFrequency",
        reportTypes: ["LINEAR"],
        type: "dimension",
        operation: "none",
        unit: "none",
        isExclusiveFrequencyDimension: true
    },
    linearConversions: {
        label: "Conversions",
        description: "Total number of conversions attributed to linear campaign",
        id: "linearConversions",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none"
    },
    linearUniqueConversions: {
        label: "Unique Conversions",
        description: "Number of unique users who converted",
        id: "linearUniqueConversions",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "attribution",
        operation: "sum",
        unit: "none"
    },
    linearUniqueConversionRate: {
        label: "Unique Conversion Rate",
        description: "Percentage of unique users who converted",
        id: "linearUniqueConversionRate",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "percentage"
    },
    linearConversionRate: {
        label: "Conversion Rate",
        description: "Percentage of impressions that resulted in conversions",
        id: "linearConversionRate",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "attribution",
        operation: "average",
        unit: "percentage"
    },
    linearAverageFrequency: {
        label: "Average Frequency",
        description: "Average number of times a user saw the ad",
        id: "linearAverageFrequency",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "none"
    },
    linearProjectedHouseholds: {
        label: "Reach",
        description: "Projected unique household reach",
        id: "linearProjectedHouseholds",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    linearImpressions: {
        label: "Impressions",
        description: "Total number of impressions delivered",
        id: "linearImpressions",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    linearReachRate: {
        label: "Reach Rate",
        description: "Percentage of target audience reached",
        id: "linearReachRate",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "impression",
        operation: "average",
        unit: "percentage"
    },
    linearReach: {
        label: "Reach",
        description: "Projected unique IP reach",
        id: "linearReach",
        reportTypes: ["LINEAR"],
        type: "metric",
        metricSource: "impression",
        operation: "sum",
        unit: "none"
    },
    footfallVisitDay: {
        label: "Day of Visit",
        description: "Date on which footfall visit occurred",
        id: "footfallVisitDay",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        isFootfallField: true,
        isConversionTime: true
    },
    footfallVisitDayOfWeek: {
        label: "Visit Day of Week",
        description: "Day of the week on which footfall visit occurred",
        id: "footfallVisitDayOfWeek",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        isFootfallField: true,
        isConversionTime: true
    },
    footfallCity: {
        label: "City",
        description: "City in which footfall visit occurred",
        id: "footfallCity",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        isFootfallField: true,
        isConversionTime: true
    },
    footfallState: {
        label: "State",
        description: "State in which footfall visit occurred",
        id: "footfallState",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        isFootfallField: true,
        isConversionTime: true
    },
    footfallZipcode: {
        label: "Zipcode",
        description: "Zipcode in which footfall visit occurred",
        id: "footfallZipcode",
        reportTypes: ["VIDEO", "AUDIO", "DISPLAY"],
        type: "dimension",
        operation: "none",
        unit: "none",
        canUserQueryBy: true,
        isFootfallField: true,
        isConversionTime: true
    }
};
//# sourceMappingURL=configuration.js.map